import React from 'react';
import { List, ListItem } from 'react-md';
import { dat_dFechas, dat_salario } from '../requests/req_general';

export default class Filtros extends React.Component {
    constructor(props) {
        super(props)
        this.addFltrs = this.addFltrs.bind(this);
        this.quitaFlitro = this.quitaFlitro.bind(this);
        this.openMenuMvl = this.openMenuMvl.bind(this);
        this.GeneraFltStd = this.GeneraFltStd.bind(this);
        this.GeneraFltrCdd = this.GeneraFltrCdd.bind(this);
        this.GeneraFltrJrnd = this.GeneraFltrJrnd.bind(this);
        this.GeneraFltrCtgr = this.GeneraFltrCtgr.bind(this);
        this.filtrosPrevios = this.filtrosPrevios.bind(this);
        this.GeneraFltrFecha = this.GeneraFltrFecha.bind(this);
        this.GeneraFltrCntrt = this.GeneraFltrCntrt.bind(this);
        this.estableceFiltros = this.estableceFiltros.bind(this);
        this.GeneraFltrSalario = this.GeneraFltrSalario.bind(this);
    }

    componentDidMount() {

    }
    componentWillMount() {

    }

    quitaFlitro(e) {
        var elm = e.target;
        if (!elm.classList.contains('dv_fltrs_app')) {
            var btn = (elm.tagName === 'IMG' ? elm.parentElement : elm),
                nm = btn.getAttribute('nombre'), dvMstr = document.getElementById('dv_flt_' + nm),
                padre = document.getElementById('dv_fltrs_app');
            if (nm !== 'idPuesto' && dvMstr) {
                dvMstr.classList.remove('Hide_All');
            }
            padre.removeChild(btn);
            this.estableceFiltros();
        }
    }

    addFltrs(e) {
        var elm = e.target,
            dv = (elm.classList.contains('md-fake-btn') ? elm : elm.parentElement),
            Mdv = (dv.classList.contains('md-fake-btn') ? dv : dv.parentElement),
            texto = elm.innerText,
            img = window.origin + '/images/icon_cls_crcl.png',
            d = document.getElementById('dv_fltrs_app'),
            nombr = dv.getAttribute('name'),
            dvOcultar = document.getElementById('dv_flt_' + nombr),
            valor = (nombr !== 'salario' ? dv.getAttribute('id') : (dv.getAttribute('desde') + '_' + dv.getAttribute('hasta')));
        d.innerHTML += '<button class="Btn_Fltr" nombre="' + nombr + '" valor="' + valor + '" >' + texto + ' <img src=' + img + ' alt=" "/></button>';

        if (dvOcultar) dvOcultar.classList.add('Hide_All');

        this.estableceFiltros();
    }

    filtrosPrevios() {
        if (this.props.fdflt !== null) {
            var img = window.origin + '/images/icon_cls_crcl.png';
            var fltsprvs = this.props.fdflt.filter((f) => f.valor !== '');
            return fltsprvs.map((a, index) => {
                var dv = document.getElementById('dv_flt_' + a.tipo);
                if (dv !== null) {
                    var dm = document.getElementById('dv_flt_idMunicipio');
                    dv.classList.add('Hide_All');
                    dm.classList.remove('Hide_All');
                }
                return (<button className="Btn_Fltr" nombre={a.tipo} valor={a.valor} key={index}>{a.filtro} <img src={img} alt=" " /></button>);
            });
        }
    }

    estableceFiltros() {
        var btns = document.querySelectorAll('.Btn_Fltr'),
            lb = document.getElementById('lbl_fltrs_orft'),
            j = '{ ';
        btns.forEach(function (b) {
            var nm = b.getAttribute('nombre'),
                vl = b.getAttribute('valor');
            if (nm === 'salario') {
                var slds = vl.split('_');
                j += '"SueldoMin":"' + slds[0] + '","SueldoMax":"' + slds[1] + '",';
            } else {
                j += '"' + nm + '":"' + vl + '",';
            }
        });
        j = j.substring(0, j.length - 1);
        j += '}';
        lb.innerText = j;
        this.props.action(j);
    }

    //Genera los elementos de los filtros de fecha
    GeneraFltrFecha() {
        this.openMenuMvl(true)
        return dat_dFechas.map((a, index) => {
            return (<ListItem primaryText={a.texto} id={a.valor} name='fechas' key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
        });
    }

    //Genera los elementos de los filtros de Salario
    GeneraFltrSalario() {
        this.openMenuMvl(true)
        return dat_salario.map((a, index) => {
            return (<ListItem primaryText={a.texto} desde={a.desde} name='salario' hasta={a.hasta} key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
        });
    }

    //Genera los elementos de los filtros de Contrato
    GeneraFltrCntrt() {
        this.openMenuMvl(true)
        if (this.props.cntr !== null) {
            return this.props.cntr.map((a, index) => {
                return (<ListItem primaryText={a.descripcion} id={a.descripcion} name='Contratacion' key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
            });
        }
    }

    //Genera los elementos de los filtros de Jornada
    GeneraFltrJrnd() {
        this.openMenuMvl(true)
        if (this.props.jrnds !== null) {
            return this.props.jrnds.map((a, index) => {
                return (<ListItem primaryText={a.descripcion} id={a.descripcion} name='Jornada' key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
            });
        }
    }

    //Genera los elementos de los filtros de Categoría
    GeneraFltrCtgr() {
        this.openMenuMvl(true)
        if (this.props.cats !== null) {
            return this.props.cats.map((a, index) => {
                return (<ListItem primaryText={a.descripcion} id={a.idValor} name='idCategoria' key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
            });
        }
    }

    //Genera los elementos de los filtros de Ciudad
    GeneraFltrCdd() {
        this.openMenuMvl(true)
        if (this.props.muni !== null) {
            return this.props.muni.map((a, index) => {
                return (<ListItem primaryText={a.municipio} id={a.idMunicipio} name='idMunicipio' key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
            });
        }
    }

    GeneraFltStd() {
        this.openMenuMvl(true)
        if (this.props.estds !== null) {
            return this.props.estds.map((a, index) => {
                return (<ListItem primaryText={a.estado} id={a.idEstado} name='idEstado' key={index} className='Lst_Fltr_Opc' onClick={(e) => this.addFltrs(e)} />);
            });
        }
    }

    //Función para extender el menú en móvil
    openMenuMvl(flag) {
        var dv = document.getElementById('dv_Ofertas');
        var exp = document.getElementsByClassName('ARC_Ofr_Vcnts')[0]
        if (dv !== null) {
            if (flag) {
                return dv.classList.remove('dv_filtros_open'), exp.classList.remove('dv_open_vcts');
            }
            if (!dv.classList.contains('dv_filtros_open')) {
                dv.classList.add('dv_filtros_open');
                exp.classList.add('dv_open_vcts');
            } else {
                dv.classList.remove('dv_filtros_open');
                exp.classList.remove('dv_open_vcts');
            }
        }
    }



    render() {
        return (
            <div className="ARC_Ofr_fltr_dv">
                <label>Filtros</label>
                <label id='lbl_fltrs_orft' className='Hide_All'></label>
                <img src={process.env.PUBLIC_URL + '/images/icon_filter.png'} alt=' ' className='Hide_Web Img_Fltr' onClick={() => this.openMenuMvl(false)} />
                <img src={process.env.PUBLIC_URL + '/images/icon_back.png'} alt=' ' className='Hide_Web Img_Bck_Fltr' onClick={() => this.openMenuMvl(false)} />
                <div id='dv_fltrs_app' className='dv_fltrs_app' onClick={(e) => this.quitaFlitro(e)}>
                    {this.filtrosPrevios()}
                </div>
                <List className="lg-cell lg-paper lg-paper--1 dv_Ftr" id='dv_flt_fechas'>
                    <label>Por Fecha:</label>
                    {this.GeneraFltrFecha()}
                </List>
                <List className="lg-cell lg-paper lg-paper--1 dv_Ftr" id='dv_flt_salario'>
                    <label>Por Salario:</label>
                    {this.GeneraFltrSalario()}
                </List>
                <List className="lg-cell lg-paper lg-paper--1 dv_Ftr" id='dv_flt_idCategoria'>
                    <label>Categoría:</label>
                    {this.GeneraFltrCtgr()}
                </List>
                <List className={'lg-cell lg-paper lg-paper--1 dv_Ftr'} id='dv_flt_idEstado'>
                    <label>Estado:</label>
                    {this.GeneraFltStd()}
                </List>
                <List className={'lg-cell lg-paper lg-paper--1 dv_Ftr'} id='dv_flt_idMunicipio'>
                    <label>Ciudad:</label>
                    {this.GeneraFltrCdd()}
                </List>
                <List className="lg-cell lg-paper lg-paper--1 dv_Ftr" id='dv_flt_Contratacion'>
                    <label>Tipo Contrato:</label>
                    {this.GeneraFltrCntrt()}
                </List>
                <List className="lg-cell lg-paper lg-paper--1 dv_Ftr" id='dv_flt_Jornada'>
                    <label>Tipo Jornada:</label>
                    {this.GeneraFltrJrnd()}
                </List>
            </div>
        );
    }
}